<div class="fw-tags-dialog">
  <div class="fw-tags-dialog__header">
    <h2 class="fw-tags-dialog__title">
      {{
        frameworkType === 'STANDARD'
          ? ('translations.framework.label.addTagsFromFramework' | transloco)
          : ('translations.framework.label.addCategories' | transloco)
      }}
    </h2>
    <button class="fw-tags-dialog__close" type="button" (click)="onClose()">
      <ptl-icon [icon]="LucideX" size="m"></ptl-icon>
    </button>
  </div>

  <div class="fw-tags-dialog__body">
    @if (dialogState === 'loading') {
      <div class="fw-tags-dialog__loading">
        <mat-spinner [diameter]="40"></mat-spinner>
      </div>
    }

    @if (dialogState === 'error') {
      <p class="fw-tags-dialog__message">{{ 'translations.errors.errorGetFrameworks' | transloco }}</p>
    }

    @if (dialogState === 'ready') {
      <div class="fw-tags-dialog__panels" [class.fw-tags-dialog__panels--single]="frameworkType === 'CATEGORIES'">
        @if (frameworkType !== 'CATEGORIES') {
          <div class="fw-tags-dialog__frameworks-panel">
            @for (item of allItems; track item.id) {
              <button
                class="fw-tags-dialog__framework-item"
                [class.fw-tags-dialog__framework-item--active]="activeFrameworkId === item.id"
                type="button"
                (click)="onSelectFramework(item.id)"
              >
                <span class="fw-tags-dialog__framework-title">{{ item.title }}</span>
                @if (item.type === 'taxonomy') {
                  <span class="fw-tags-dialog__framework-badge">{{ 'translations.framework.label.skillTaxonomies' | transloco }}</span>
                }
              </button>
            }

            @if (allItems.length === 0) {
              <p class="fw-tags-dialog__empty-message">{{ 'translations.framework.label.noFrameworksMessage' | transloco }}</p>
            }
          </div>
        }

        <div class="fw-tags-dialog__tags-panel" (scroll)="isEscoMode ? onEscoTagsScroll($event) : null">
          @if (isEscoMode) {
            <div class="fw-tags-dialog__esco-search">
              <div class="fw-tags-dialog__esco-search-input-wrapper">
                <ptl-icon class="fw-tags-dialog__esco-search-icon" [icon]="LucideSearch" size="s"></ptl-icon>
                <input
                  class="fw-tags-dialog__esco-search-input"
                  type="text"
                  [placeholder]="'translations.framework.label.escoSearchPlaceholder' | transloco"
                  [value]="escoSearchTerm"
                  (input)="onEscoSearchInput($event)"
                />
              </div>
            </div>
            @if (escoSearchLoading) {
              <div class="fw-tags-dialog__tags-loading">
                <mat-spinner [diameter]="30"></mat-spinner>
              </div>
            } @else {
              @if (escoSearchTerm.length < 2) {
                <p class="fw-tags-dialog__empty-message">{{ 'translations.framework.label.escoSearchHint' | transloco }}</p>
              }
              @if (escoSearchTerm.length >= 2 && escoSkills.length === 0) {
                <p class="fw-tags-dialog__empty-message">{{ 'translations.framework.label.noEscoResultsFound' | transloco }}</p>
              }
              <div class="fw-tags-dialog__tags-list">
                @for (result of escoSkills; track result.conceptUri) {
                  <div class="fw-tags-dialog__tag-item" [class.fw-tags-dialog__tag-item--existing]="isEscoResultExisting(result)">
                    <ptl-sg-checkbox
                      class="fw-tags-dialog__tag-checkbox"
                      [checked]="isEscoResultExisting(result) || isEscoResultSelected(result)"
                      [disabled]="isEscoResultExisting(result)"
                      [matTooltip]="isEscoResultExisting(result) ? ('translations.framework.label.tagAlreadyAdded' | transloco) : ''"
                      matTooltipPosition="above"
                      [matTooltipShowDelay]="500"
                      (checkboxChange)="onSelectEscoResult(result)"
                      [size]="'l'"
                    >
                      <span class="fw-tags-dialog__tag-label">{{ result.preferredLabel }}</span>
                    </ptl-sg-checkbox>
                  </div>
                }
              </div>
              @if (escoLoadingMore) {
                <div class="fw-tags-dialog__tags-loading">
                  <mat-spinner [diameter]="24"></mat-spinner>
                </div>
              }
            }
          } @else {
            @if (tagsLoading) {
              <div class="fw-tags-dialog__tags-loading">
                <mat-spinner [diameter]="30"></mat-spinner>
              </div>
            } @else {
              @if (isNestedLevel) {
                <nav class="fw-tags-dialog__breadcrumbs">
                  <button class="fw-tags-dialog__breadcrumb-item" type="button" (click)="onBreadcrumbClick(-1)">
                    {{ activeFrameworkTitle }}
                  </button>
                  @for (crumb of breadcrumbs; track crumb.id; let last = $last) {
                    <span class="fw-tags-dialog__breadcrumb-separator">/</span>
                    @if (last) {
                      <span class="fw-tags-dialog__breadcrumb-current">{{ crumb.title }}</span>
                    } @else {
                      <button class="fw-tags-dialog__breadcrumb-item" type="button" (click)="onBreadcrumbClick($index)">
                        {{ crumb.title }}
                      </button>
                    }
                  }
                </nav>
              }

              @if (displayedTags.length === 0 && !tagsLoading) {
                <p class="fw-tags-dialog__empty-message">{{ 'translations.framework.label.noTagsAvailable' | transloco }}</p>
              }

              <div class="fw-tags-dialog__tags-list">
                @for (tag of displayedTags; track tag._id) {
                  <div class="fw-tags-dialog__tag-item" [class.fw-tags-dialog__tag-item--existing]="isTagExisting(tag)">
                    <ptl-sg-checkbox
                      class="fw-tags-dialog__tag-checkbox"
                      [checked]="isTagExisting(tag) || isTagSelected(tag)"
                      [disabled]="isTagExisting(tag)"
                      [matTooltip]="isTagExisting(tag) ? ('translations.framework.label.tagAlreadyAdded' | transloco) : ''"
                      matTooltipPosition="above"
                      [matTooltipShowDelay]="500"
                      (checkboxChange)="onSelectTag(tag)"
                      [size]="'l'"
                    >
                      <span class="fw-tags-dialog__tag-label">{{ tag.title }}</span>
                    </ptl-sg-checkbox>
                    @if (tag.descendantsCount) {
                      <button class="fw-tags-dialog__tag-more-btn" type="button" (click)="onLoadNestedTags(tag)">
                        <span>{{ tag.descendantsCount }} {{ 'translations.global.button.more' | transloco }}</span>
                        <ptl-icon [icon]="LucideArrowRight" size="xs"></ptl-icon>
                      </button>
                    }
                  </div>
                }
              </div>
            }
          }
        </div>
      </div>

      @if (selectedTags.length > 0) {
        <div class="fw-tags-dialog__selected-tags">
          <span class="fw-tags-dialog__selected-label">{{ 'translations.framework.label.selectedTags' | transloco }}</span>
          <div class="fw-tags-dialog__selected-badges">
            @for (tag of selectedTags; track tag._id) {
              <ptl-base-badge [size]="'l'" [color]="'brand'" [text]="tag.title">
                <ptl-icon
                  tabindex="0"
                  role="button"
                  class="fw-tags-dialog__remove-badge"
                  (keydown.enter)="onRemoveSelectedTag(tag)"
                  (click)="onRemoveSelectedTag(tag)"
                  [icon]="LucideX"
                  [size]="'xs'"
                ></ptl-icon>
              </ptl-base-badge>
            }
          </div>
        </div>
      }
    }
  </div>

  <div class="fw-tags-dialog__separator"></div>
  <div class="fw-tags-dialog__actions">
    <ptl-button
      [type]="'secondary-neutral'"
      size="l"
      [text]="'translations.global.button.cancel' | transloco"
      [fullWidth]="true"
      (clicked)="onCancel()"
    ></ptl-button>
    <ptl-button
      [type]="'primary'"
      size="l"
      [text]="
        frameworkType === 'STANDARD'
          ? ('translations.framework.button.addTags' | transloco)
          : ('translations.framework.button.addCategories' | transloco)
      "
      [fullWidth]="true"
      [disabled]="selectedTags.length === 0"
      (clicked)="onAddTags()"
    ></ptl-button>
  </div>
</div>
